





































import { Prop, Vue, Component } from 'vue-property-decorator';
import firebase from 'firebase/app';

@Component({
    name: 'Backend'
})
export default class Backned extends Vue {
  @Prop() private msg!: string;
  private username = ''
  private password = ''
  private signedIn = false

  private isLoading = false
  private message = ''
  private color = ''
  private backgroundColor = ''
  private error: unknown = null

  async sha256 (message: string) {
    // encode as UTF-8
    const msgBuffer = new TextEncoder().encode(message);                    

    // hash the message
    const hashBuffer = await crypto.subtle.digest('SHA-256', msgBuffer);

    // convert ArrayBuffer to Array
    const hashArray = Array.from(new Uint8Array(hashBuffer));

    // convert bytes to hex string                  
    const hashHex = hashArray.map(b => ('00' + b.toString(16)).slice(-2)).join('');
    return hashHex;
  }

  private async login () {
    // const provider = new firebase.auth.GoogleAuthProvider();
    // provider.addScope('https://www.googleapis.com/auth/contacts.readonly');
    // firebase.auth().useDeviceLanguage();
    // firebase.auth().signInWithPopup(provider).then((result) => {
    //   // This gives you a Google Access Token. You can use it to access the Google API.
    //   console.log(result)
    // }).catch((error) => {
    //   console.log(error)
    // });

    // console.log(provider);
    

    this.isLoading = true;
    const db = firebase.firestore();
    const snapshot = await db.collection('users').get();
    snapshot.forEach(async (doc) => {
      // console.log(doc.id, '=>', doc.data());

      const { name, password } = doc.data();
      firebase.auth().signInWithEmailAndPassword(this.username, this.password).then(async () => {
        const session = await db.collection('session').doc('ecQGbkfmg7F1xo5iVziC').get();
        // console.log(session.id, '=>', session);
        const data = session.data();
        // console.log(data)
        if (!data) {
          return
        }
        const { message, bgColor, fontColor } = data
        this.message = message
        this.color = fontColor
        this.backgroundColor = bgColor
        
        this.isLoading = false;
        this.signedIn = true
      }).catch((err) => {
        console.error(err);
        this.isLoading = false;
        this.error = err;
      })
    });
  }

  private async save () {
    this.isLoading = true;
    const db = firebase.firestore()
    await db.collection('session').doc('ecQGbkfmg7F1xo5iVziC').update({
      message: this.message,
      fontColor: this.color,
      bgColor: this.backgroundColor
    });    

    this.isLoading = false;
  }
}
